export enum EVENT_TYPE {
  PASS_RESTORE_INSTRUCTIONS_SENT = 'PASS_RESTORE_INSTRUCTIONS_SENT',
  CREDIT_APPLICATION_SUBMITTED = 'CREDIT_APPLICATION_SUBMITTED',
  USER_SIGNED_UP = 'USER_SIGNED_UP',
  CONNECTION_ESTABLISHED = 'CONNECTION_ESTABLISHED',
  PAYMENT_SUCCESS = 'paymentSuccess',
  PAYMENT_FAIL = 'paymentFail',
}
